var _path, _path2, _polygon, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CloudRefresh50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3dd9eb",
    d: "M37.226,14.477c-0.037,0-0.075,0.006-0.112,0.006C35.252,8.97,30.091,5,24,5 s-11.252,3.97-13.115,9.483c-0.037,0-0.074-0.006-0.112-0.006c-5.513,0-9.891,4.91-9.076,10.635C2.352,29.707,6.462,33,11.059,33 H11.2h25.6h0.141c4.599,0,8.707-3.293,9.361-7.888C47.117,19.387,42.739,14.477,37.226,14.477z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M23.711,38c-3.584,0-6.5-2.916-6.5-6.5s2.916-6.5,6.5-6.5c2.43,0,4.552,1.34,5.667,3.32l3.911-1.118 C31.645,23.55,27.971,21,23.711,21c-5.79,0-10.5,4.71-10.5,10.5s4.71,10.5,10.5,10.5c4.18,0,7.797-2.456,9.485-6h-4.8 C27.214,37.232,25.551,38,23.711,38z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2100c4",
    points: "32.255,32.597 26.782,27.958 34.776,25.88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2100c4",
    d: "M17.211,31.5c0-3.584,2.916-6.5,6.5-6.5c2.43,0,4.552,1.34,5.667,3.32l3.911-1.118 C31.645,23.55,27.971,21,23.711,21c-5.79,0-10.5,4.71-10.5,10.5c0,0.511,0.049,1.009,0.12,1.5h4.062 C17.278,32.518,17.211,32.017,17.211,31.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CloudRefresh50);
export default __webpack_public_path__ + "static/media/icons8-cloud-refresh-50.b2f67162a51fe16cbe6a753c706a40a4.svg";
export { ForwardRef as ReactComponent };